import React, { useEffect, useState } from "react";
import { Users, UserPlus, Activity, CreditCard, Upload } from "lucide-react";
import { GOLD } from "../constants/theme";
import { supabase } from "../../supabaseClient";
import { useAdmin } from "./AdminContext";

// Live admin heartbeat — a thin floating bar that appears bottom-center
// only when admin mode is on. Polls admin_live_metrics() every 30s.
export function AdminMetricsBar() {
  const { isAdmin, adminMode } = useAdmin();
  const [m, setM] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!isAdmin || !adminMode) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data, error } = await supabase.rpc("admin_live_metrics");
        if (error) throw error;
        if (!cancelled) { setM(data); setErr(false); }
      } catch {
        if (!cancelled) setErr(true);
      }
    };
    poll();
    const iv = setInterval(poll, 30000);
    return () => { cancelled = true; clearInterval(iv); };
  }, [isAdmin, adminMode]);

  if (!isAdmin || !adminMode) return null;

  const Stat = ({ icon, label, value, highlight }) => (
    <div style={{display:"flex",alignItems:"center",gap:6,padding:"0 10px",borderLeft:"1px solid rgba(255,255,255,0.08)"}}>
      <span style={{color:highlight ? GOLD : "rgba(255,255,255,0.65)",display:"inline-flex",alignItems:"center"}}>{icon}</span>
      <span style={{fontSize:11,color:"rgba(255,255,255,0.7)",fontWeight:600}}>{label}</span>
 <span style={{fontSize:12,fontWeight:800,color:highlight?GOLD:"#F5F5F5"}}>{value ?? "-"}</span>
    </div>
  );

  return (
    <div style={{
      position:"fixed",bottom:68,right:20,zIndex:4999,
      display:"flex",alignItems:"center",gap:0,
      padding:"7px 4px 7px 14px",borderRadius:20,
      background:"rgba(10,10,10,0.85)",border:"1px solid rgba(226,221,159,0.3)",
      backdropFilter:"blur(10px)",
      boxShadow:"0 8px 24px rgba(0,0,0,0.4)",
      fontFamily:"'DM Sans',sans-serif",
    }}>
      <span style={{fontSize:9,fontWeight:800,color:GOLD,letterSpacing:1.4,textTransform:"uppercase",marginRight:2}}>Live</span>
      {err ? (
        <Stat icon={<Activity size={11}/>} label="metrics" value="err"/>
      ) : (
        <>
          <Stat icon={<Users size={11}/>}      label="members" value={m?.total_members}/>
          <Stat icon={<UserPlus size={11}/>}   label="today"   value={m?.signups_today} highlight/>
          <Stat icon={<Activity size={11}/>}   label="7d"      value={m?.active_7d}/>
          <Stat icon={<CreditCard size={11}/>} label="subs"    value={m?.subscribed}/>
          <Stat icon={<Upload size={11}/>}     label="pending" value={m?.pending_uploads} highlight={m?.pending_uploads > 0}/>
        </>
      )}
    </div>
  );
}

export default AdminMetricsBar;
